import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StackTestState {
  stackTestData: any;
  // ... other state properties
}

const initialState: StackTestState = {
  stackTestData: {},
  // ... other initial state
};

const stackTestSlice = createSlice({
  name: 'stackTest',
  initialState,
  reducers: {
    setStackTestData: (state, action: PayloadAction<any>) => {
      state.stackTestData = action.payload;
    },
    // ... other reducers
  }
});

export const { setStackTestData } = stackTestSlice.actions;
export default stackTestSlice.reducer; 